import { createApp } from 'vue';
import TiffToPdfConverter from '@/Components/TiffToPdfConverter.vue';
import '@styles/app.css';

createApp(TiffToPdfConverter).mount('#tiff-to-pdf-converter');
